import { cn } from '@/lib/utils';

import ThinkingContent from './ThinkingContent';

interface TextFieldProps {
  value: string;
  isUserMessage: boolean;
}

export default function TextField({ value, isUserMessage }: TextFieldProps) {
  const isThinking =
    value.includes('<lb_think>') && value.includes('</lb_think>');

  if (isThinking) {
    const thinkingMatch = value.match(/<lb_think>(.*?)<\/lb_think>/s);
    const thinkingContent = thinkingMatch ? thinkingMatch[1].trim() : '';
    const remaining = value.replace(/<lb_think>.*?<\/lb_think>/s, '').trim();
    return (
      <div className="space-y-2">
        {thinkingContent && <ThinkingContent content={thinkingContent} />}
        {remaining && (
          <div
            className={cn(
              'whitespace-pre-wrap text-sm leading-relaxed',
              !isUserMessage && 'py-2'
            )}
            style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
          >
            {remaining}
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      className={cn(
        'whitespace-pre-wrap text-sm leading-relaxed',
        isUserMessage ? 'text-foreground' : 'py-2 text-foreground/90'
      )}
      style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
    >
      {value}
    </div>
  );
}
